import { render, staticRenderFns } from "./Earnings.vue?vue&type=template&id=21b29530&scoped=true&"
import script from "./Earnings.vue?vue&type=script&lang=js&"
export * from "./Earnings.vue?vue&type=script&lang=js&"
import style0 from "./Earnings.vue?vue&type=style&index=0&id=21b29530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b29530",
  null
  
)

export default component.exports